module.exports = __webpack_public_path__ + "img/kong_big@2x.2661275f.png";